import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { InputAdornment, TextField } from '@material-ui/core';
import { getValidAmountInput } from './refundFormat';
import { MAX_REFUND_AMOUNT } from './constants';

// Amount input using inputMode="decimal" (no native number spinners), with a currency-symbol
// adornment, right-aligned tabular figures, and validated input (invalid keystrokes ignored).
const styles = () => ({
  root: {
    width: 128,
  },
  input: {
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
});

const MoneyField = ({ classes, value, onChange, currencySymbol, decimals, error, disabled, ariaLabel }) => (
  <TextField
    type="text"
    margin="none"
    value={value}
    disabled={disabled}
    error={error}
    onChange={e => {
      const next = getValidAmountInput(e.target.value, decimals, MAX_REFUND_AMOUNT);
      if (next !== null) onChange(next);
    }}
    className={classes.root}
    InputProps={{
      startAdornment: <InputAdornment position="start">{currencySymbol}</InputAdornment>,
      inputProps: { inputMode: 'decimal', 'aria-label': ariaLabel, className: classes.input },
    }}
  />
);

MoneyField.propTypes = {
  classes: PropTypes.shape({}),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  currencySymbol: PropTypes.string,
  decimals: PropTypes.number,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  ariaLabel: PropTypes.string,
};

export const MoneyFieldTest = MoneyField;

export default withStyles(styles)(MoneyField);
